
import axios from "axios";
import headings from "~/mixins/headings.js";

export default {
  mixins: [headings],
  async asyncData({ store, route, params, error }) {
    try {
      let response;
      if (route.query.preview) {
        response = await axios.get(
          `${store.state.wsPath}preview?type=magazine&pid=${params.id}&lang=${store.state.lang}&market=${store.state.market}&email=${store.state.user.email}&token=${store.state.user.token}`
        );
      } else {
        response = await axios.get(
          `${store.state.wsPath}get?type=magazine/${params.id}&lang=${store.state.lang}&market=${store.state.market}`
        );
      }

      return {
        error: response.data.error,
        data: response.data,
      };
    } catch (e) {
      error({ statusCode: 500, message: store.state.labels.error_occurred });
    }
  },
};
